import { render, staticRenderFns } from "./AdminCommissionsHome.vue?vue&type=template&id=2278dfbc&scoped=true"
import script from "./AdminCommissionsHome.vue?vue&type=script&lang=js"
export * from "./AdminCommissionsHome.vue?vue&type=script&lang=js"
import style0 from "./AdminCommissionsHome.vue?vue&type=style&index=0&id=2278dfbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278dfbc",
  null
  
)

export default component.exports